/* Leaft Blade V2 — geo notice and market routing.

   Detects the visitor's country and, if it differs from this storefront's home
   country, shows either a waitlist message (markets we can't ship to) or a
   reroute link (the US store). Dismissible + remembered.

   Market routing (20 Oct 2026): a US visitor on the NZ product page is sent
   straight to the US twin (same query string and hash) with location.replace,
   because the NZ product is stocked in Canterbury only and a US checkout on it
   says "doesn't ship to your area". Not for bots, not in the theme editor, and
   not for a visitor who dismissed the notice before: they get the notice with
   the deep link instead. Every other page keeps the notice to /en-us.

   Country detection: Shopify's own /browsing_context_suggestions.json first
   (the signal checkout and the market switcher use), then ipapi.co with a
   short timeout as the fallback. Both fail silent: the notice simply never
   shows on error. ?lb2_geo=US forces a country for testing. */
(() => {
  const root = document.querySelector('[data-lb2-geo]');
  if (!root) return;

  const DISMISS_KEY = 'lb2-geo-dismissed';
  let dismissed = false;
  try { dismissed = localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { /* storage blocked */ }

  const configEl = document.querySelector('[data-lb2-geo-config]');
  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const home = (root.dataset.homeCountry || 'NZ').toUpperCase();
  const usUrl = root.dataset.usUrl;
  const rootUrl = (root.dataset.rootUrl || '').replace(/\/$/, '');
  const twinUrl = root.dataset.usProductUrl || '';
  const nzHandle = root.dataset.nzHandle || '';
  const pageHandle = root.dataset.pageHandle || '';
  const onNzProduct = !!(twinUrl && nzHandle && pageHandle && pageHandle === nzHandle);
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const isBot = /bot|crawl|spider|slurp|facebookexternalhit|lighthouse|headless|preview/i.test(navigator.userAgent || '');

  // Dismissed visitors see nothing, except on the NZ product page, where the
  // deep link is still offered (without the redirect).
  if (dismissed && !onNzProduct) return;

  const msgEl = root.querySelector('[data-lb2-geo-msg]');
  const ctaEl = root.querySelector('[data-lb2-geo-cta]');
  const closeEl = root.querySelector('[data-lb2-geo-close]');

  closeEl.addEventListener('click', () => {
    root.classList.remove('is-visible');
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* storage blocked */ }
  });

  function twinTarget() {
    return twinUrl + location.search + location.hash;
  }

  function show(country) {
    if (!country || country === home) return;

    const unship = config.unshippable && config.unshippable[country];
    const reroute = config.reroute && config.reroute[country];

    if (unship) {
      if (dismissed) return;
      msgEl.innerHTML = unship.message;
      ctaEl.textContent = unship.cta;
      ctaEl.href = unship.url || '#';
    } else if (reroute && country === 'US' && onNzProduct) {
      if (!dismissed && !designMode && !isBot) {
        location.replace(twinTarget());
        return;
      }
      msgEl.innerHTML = reroute.message;
      ctaEl.textContent = reroute.cta_product || reroute.cta;
      ctaEl.href = twinTarget();
    } else if (reroute && usUrl) {
      if (dismissed) return;
      msgEl.innerHTML = reroute.message;
      ctaEl.textContent = reroute.cta;
      ctaEl.href = usUrl;
    } else {
      return;
    }
    root.classList.add('is-visible');
  }

  function fallbackLookup() {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), 2500);
    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        clearTimeout(t);
        if (data && data.country_code) show(String(data.country_code).toUpperCase());
      })
      .catch(() => {});
  }

  function detect() {
    const forced = new URLSearchParams(location.search).get('lb2_geo');
    if (forced && /^[A-Za-z]{2}$/.test(forced)) {
      show(forced.toUpperCase());
      return;
    }
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), 2500);
    fetch(`${rootUrl}/browsing_context_suggestions.json`, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        clearTimeout(t);
        const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (country) {
          show(String(country).toUpperCase());
        } else {
          fallbackLookup();
        }
      })
      .catch(() => fallbackLookup());
  }

  detect();
})();
